import React from "react";
import { Link } from "react-router-dom";
import "../css/about.scss";

const storyPoints = [
  {
    number: "01",
    title: "Made for daily use",
    text: "Practical formats and considered materials help creative tools fit naturally into everyday routines.",
  },
  {
    number: "02",
    title: "Designed to stay useful",
    text: "Clear organization turns scattered notes and tools into a workspace you can return to with ease.",
  },
  {
    number: "03",
    title: "Rooted in creativity",
    text: "ioomparade celebrates the quiet satisfaction of writing, sketching, planning, and making by hand.",
  },
];

function About() {
  return (
    <main className="ink-info-page ink-info-page--about">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Our story</p>
          <h1>About ioomparade</h1>
          <p className="ink-info-page__lead">
            Thoughtful stationery and desk essentials designed in Hong Kong for
            creative routines everywhere.
          </p>
        </header>

        <section className="about-story" aria-labelledby="about-story-title">
          <figure className="about-story__figure">
            <img
              src="/main/ioomparade/about-story.png"
              alt="ioomparade designers reviewing notebook prototypes and paper samples"
            />
            <figcaption>
              Reviewing paper, binding, and material samples in our Hong Kong
              design workspace.
            </figcaption>
          </figure>

          <div className="about-story__copy">
            <p className="ink-info-page__kicker">Designed with purpose</p>
            <h2 id="about-story-title">Useful objects for ideas in motion</h2>
            <p>
              ioomparade began with a simple belief: creative tools should feel
              good in the hand, work reliably, and look at home in the spaces
              where real life happens.
            </p>
            <p>
              From page layouts to storage details, each item is developed around
              a clear everyday purpose. We favor durable materials, comfortable
              proportions, and calm colors that are easy to combine.
            </p>
            <p>
              Our collection grows across notebooks, writing instruments, and
              desktop organization while keeping the same focus: helping people
              make space for thoughtful work and playful ideas.
            </p>
            <Link className="ink-info-page__button" to="/shop">
              Explore the collection
            </Link>
          </div>
        </section>

        <section className="about-values" aria-labelledby="about-values-title">
          <div className="about-values__heading">
            <p className="ink-info-page__kicker">Why ioomparade</p>
            <h2 id="about-values-title">Keep your creative routine together</h2>
          </div>
          <div className="about-values__grid">
            {storyPoints.map((point) => (
              <article className="about-value" key={point.number}>
                <span aria-hidden="true">{point.number}</span>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </article>
            ))}
          </div>
        </section>

        <aside className="about-contact" aria-labelledby="about-contact-title">
          <div>
            <p className="ink-info-page__kicker">Stay curious</p>
            <h2 id="about-contact-title">Questions, comments, or an inky idea?</h2>
          </div>
          <Link className="ink-info-page__text-link" to="/contact">
            Contact ioomparade <span aria-hidden="true">&#8594;</span>
          </Link>
        </aside>
      </div>
    </main>
  );
}

export default About;
